export default "__VITE_ASSET__aI62sQCP__"